import { AxiosResponse } from "axios";
import { $leiApi } from "../..";

export class SearchLeiCode {
  static async requestSearchLeiCode(page:number): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records?page[size]=20&page[number]=${page}`);
  }
  static async searchLeiByCompanyName(name: string, jurisdiction: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records?filter[entity.names]=${encodeURIComponent(name)}&filter[entity.jurisdiction]=${jurisdiction}`);
  }
  static async searchLeiByLei(lei: string, jurisdiction: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records?filter[lei]=${encodeURIComponent(lei)}&filter[entity.jurisdiction]=${jurisdiction}`);
  }
  static async getLei(lei: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}`);
  }
  static async getManagingLou(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/managing-lou`);
  }
  static async getLeiIssuer(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/lei-issuer`);
  }
  static async getDirectParent(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/direct-parent`);
  }
  static async getUltimateParent(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/ultimate-parent`);
  }
  static async getDirectChildren(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/direct-children?page[size]=100`);
  }
  static async getUltimateChildren(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/ultimate-children?page[size]=100`);
  }
  // When an entity reports no parent, GLEIF still explains why via a
  // separate "reporting exception" record (e.g. NO_KNOWN_PERSON,
  // NON_CONSOLIDATING) instead of just a 404 - fetched as a fallback when
  // getDirectParent/getUltimateParent 404.
  static async getDirectParentReportingException(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/direct-parent-reporting-exception`);
  }
  static async getUltimateParentReportingException(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/ultimate-parent-reporting-exception`);
  }
  // Cheap way to get just the total ISIN count without paging through
  // every result - the isins relationship can carry hundreds of pages.
  static async getIsinsCount(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records/${lei}/isins?page[size]=1`);
  }
  static async searchLei(lei:string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`autocompletions?field=fulltext&q=${encodeURIComponent(lei)}`);
  }
  // Autocompletions alone misses plenty of valid, exact matches (typos,
  // partial LEI codes, names it hasn't indexed as prefixes) - these three
  // are tried in sequence as fallbacks, same chain leiprofile.com uses.
  static async searchLeiFuzzy(query: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`fuzzycompletions?field=fulltext&q=${encodeURIComponent(query)}`);
  }
  static async searchLeiRecordsByLei(lei: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records?filter[lei]=${encodeURIComponent(lei)}`);
  }
  static async searchLeiRecordsByName(name: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`lei-records?filter[entity.legalName]=${encodeURIComponent(name)}`);
  }
  static async getLegalForm(id: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`entity-legal-forms/${id}`);
  }
  static async getRegistrationAuthority(id: string): Promise<AxiosResponse<any>> {
    return $leiApi.get(`registration-authorities/${id}`);
  }
}
